import React from "react";

import { PopupModal } from "components/modals/ModalBox";
import useButtonLoader from "hooks/useButtonLoader";
import { toastMessage } from "utils/toastMessage";
import { deleteCategory } from "services/category";

const DeleteCategory = ({
  deleteModal,
  selectedCategoryDetail,
  catFetchedData,
  closeModel,
}) => {
  console.log("selectedCategoryDetail:---->", selectedCategoryDetail);

  const [bannerButtonLoader, setBannerButtonLoader] = useButtonLoader("Yes");

  const deleteBannerHandler = async () => {
    try {
      setBannerButtonLoader(true);
      const {
        data: { code, status, message },
      } = await deleteCategory(selectedCategoryDetail._id);
      if (status || code === 200) {
        // Remove the deleted category from the list
        catFetchedData((prevList) =>
          prevList.filter(
            (bannerProp) => bannerProp._id !== selectedCategoryDetail._id
          )
        );
        closeModel();
        toastMessage(message, "success", "DeleteCategory");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setBannerButtonLoader(false);
    }
  };

  return (
    <>
      <PopupModal
        show={deleteModal}
        handleClose={closeModel}
        content="Are you sure you want to Delete this Category?"
        title="Delete Category"
        buttonLoader={bannerButtonLoader}
        action={deleteBannerHandler}
      />
    </>
  );
};

export default DeleteCategory;
